import { IStay, IDetailedStay } from './types/accomodation.types';

export function isDetailedStay(stay: IStay | IDetailedStay): stay is IDetailedStay {
  return (stay as IDetailedStay)?.action !== undefined;
}
